// @ts-nocheck

import * as R from 'ramda';
import { reducerWrapper } from '../../main/support/utils';
import { GET_TWILIO_NUMBERS, PAIR_TWILIO_APP } from '../actions/TwilioStartActions';

var INIT_STATE = {
  loading: false,
  error: null,
  data: {},
};

function Handler(state, action) {
  switch (action.type) {
    case GET_TWILIO_NUMBERS.response:
      return R.merge(state, {
        loading: false,
        error: null,
        data: action.data,
      });
    case PAIR_TWILIO_APP.response:
      return R.merge(state, {
        loading: false,
        error: null,
        data: action.data,
      });
    default:
      return state;
  }
}

const twilio = reducerWrapper(INIT_STATE, Handler, {
  request: [GET_TWILIO_NUMBERS, PAIR_TWILIO_APP],
  error: [GET_TWILIO_NUMBERS, PAIR_TWILIO_APP],
  resetOn: ['APP_CHANGE'],
});

export default twilio;
